import z from "zod";

const gutCheckErrorTypeValues = ["INVALID_CONVERSATION_KEY_FORMAT", "GUT_CHECK_REPORTED_ERRORS"] as const;

const gutCheckErrorTypeSchema = z.enum(gutCheckErrorTypeValues);
export const GutCheckErrorType = gutCheckErrorTypeSchema.enum;
type GutCheckErrorType = z.infer<typeof gutCheckErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GutCheckErrors =
  | {
      errorType: typeof GutCheckErrorType.INVALID_CONVERSATION_KEY_FORMAT;
      data: {
        key: string;
      };
    }
  | {
      errorType: typeof GutCheckErrorType.GUT_CHECK_REPORTED_ERRORS;
      data: {
        displayName: string;
        errors: unknown[];
        count: number;
      };
    };

export const gutCheckErrorDetails: Record<GutCheckErrorType, ErrorDetails> = {
  [GutCheckErrorType.INVALID_CONVERSATION_KEY_FORMAT]: {
    sentryDescription: "Invalid conversation key format provided to gut-check parser",
  },
  [GutCheckErrorType.GUT_CHECK_REPORTED_ERRORS]: {
    sentryDescription: "A gut check has reported errors",
  },
};
